/* Manu AI v20 (22/10/2026) — étape Vêtement : tous les vêtements, regroupés par matière (coton / polyester technique).
 * - Après « OK pour ce design », la liste n'est plus limitée au sport choisi : chaque vêtement a une matière (`fab`, calculée dans
 *   sections/ai-studio.liquid : réglage du bloc, sinon description produit, sinon coton pour CrossFit / polyester pour le running).
 * - L'onglet de la matière du sport choisi (ou du vêtement choisi) est ouvert en premier, et dans chaque groupe les vêtements du sport en premier.
 * - supportsFor() renvoie tous les vêtements une fois le design validé (couleurs, photo et lien Teeinblue suivent le vêtement choisi).
 * S'appuie sur l'instance section._ais (v9 → v19 chargés avant). */
(function () {
  'use strict';
  var TXT = {
    fr: { mat: 'Matière', coton: 'Coton', poly: 'Polyester technique' },
    en: { mat: 'Fabric', coton: 'Cotton', poly: 'Technical polyester' },
    es: { mat: 'Material', coton: 'Algodón', poly: 'Poliéster técnico' },
    de: { mat: 'Material', coton: 'Baumwolle', poly: 'Technisches Polyester' },
    it: { mat: 'Tessuto', coton: 'Cotone', poly: 'Poliestere tecnico' }
  };
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function sized(url, w) { return url ? url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w : ''; }

  function enhance(root) {
    var inst = root._ais;
    if (!inst || !inst._v18 || inst._v20) return;
    inst._v20 = true;

    // Les vêtements du sport d'abord (l'ordre du thème est gardé à l'intérieur)
    var baseFor = inst.supportsFor;
    inst.supportsFor = function (niche) {
      if (!(this.s && this.s.designOk)) return baseFor.apply(this, arguments);
      var own = baseFor.apply(this, arguments);
      return own.concat(this.supports.filter(function (x) { return own.indexOf(x) < 0; }));
    };

    // Onglets par matière : seul le groupe affiché est dans la page (la matière du vêtement choisi, sinon celle du sport)
    inst.prodsHtml = function (cur) {
      var self = this, s = this.s, T = TXT[this.loc] || TXT.fr, list = this.supportsFor(s.niche);
      var by = { coton: [], poly: [] };
      list.forEach(function (sp) { (by[sp.fab === 'poly' ? 'poly' : 'coton']).push(sp); });
      var keys = ((list[0] && list[0].fab === 'poly') ? ['poly', 'coton'] : ['coton', 'poly']).filter(function (k) { return by[k].length; });
      var on = keys.indexOf(this._fab) > -1 ? this._fab : (cur && keys.indexOf(cur.fab === 'poly' ? 'poly' : 'coton') > -1 ? (cur.fab === 'poly' ? 'poly' : 'coton') : keys[0]);
      this._fab = on;
      var tabs = keys.length > 1 ? '<div class="ais-fabtabs" role="tablist" aria-label="' + esc(T.mat) + '">' + keys.map(function (k) {
        return '<button type="button" role="tab" class="ais-fabtab" data-v20-fab="' + k + '" aria-selected="' + (k === on) + '" tabindex="' + (k === on ? 0 : -1) + '">' + esc(T[k]) + '</button>';
      }).join('') + '</div>' : '';
      return '<div class="ais-fabs" data-v20>' + tabs + '<div class="ais-prods" role="' + (tabs ? 'tabpanel' : 'group') + '" aria-label="' + esc(T[on]) + '">' + (by[on] || []).map(function (sp) {
        var ph = self.photoOf(sp, s.color), i = self.supports.indexOf(sp);
        return '<button type="button" class="ais-prod" data-v11-sup="' + i + '" aria-pressed="' + (sp === cur) + '">' +
          (ph ? '<img src="' + esc(sized(ph, 160)) + '" alt="" width="64" height="64" loading="lazy">' : '') +
          '<span class="ais-prod__n">' + esc(sp.short || String(sp.t || '').split(' (')[0].replace(/\s+À PERSONNALISER$/i, '')) + '</span><span class="ais-prod__p">' + esc(sp.price) + '</span></button>';
      }).join('') + '</div>' + (function () { var m = (by[on] || []).filter(function (x) { return x.mat; })[0]; return m ? '<p class="ais-prods__m">' + esc(cur && cur.mat && cur.fab === m.fab ? cur.mat : m.mat) + '</p>' : ''; })() + '</div>';
    };
    inst.thread.addEventListener('click', function (e) {
      var tb = e.target.closest('[data-v20-fab]');
      if (!tb || inst.busy) return;
      var box = tb.closest('[data-v20]'); if (!box) return;
      inst._fab = tb.getAttribute('data-v20-fab');
      var tmp = document.createElement('div'); tmp.innerHTML = inst.prodsHtml(inst.curSupport());
      box.replaceWith(tmp.firstChild);
      var nb = inst.thread.querySelector('[data-v20-fab][aria-selected="true"]'); if (nb) nb.focus({ preventScroll: true });
    });
    inst.thread.addEventListener('keydown', function (e) {
      var tb = e.target.closest && e.target.closest('[data-v20-fab]');
      if (!tb || (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight')) return;
      var other = tb.parentNode.querySelector('[data-v20-fab]:not([aria-selected="true"])'); if (other) { e.preventDefault(); other.click(); }
    });
    var baseReset = inst.reset;
    inst.reset = function () { this._fab = null; return baseReset.apply(this, arguments); };
    // Plus de ligne « Disponible sur … » sous les couleurs de l'étape Vêtement
    var baseAvail = inst.availText;
    inst.availText = function () { return this.s && this.s.designOk ? '' : baseAvail.apply(this, arguments); };
  }

  function boot() { document.querySelectorAll('[data-ais]').forEach(enhance); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function () { setTimeout(boot, 0); });
})();
